import { FC, useContext, useState } from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { Swap } from '../ApiTypes';
import { getSwaps } from '../api';
import { UserStateContext } from '../contexts/UserStateContext';
import { useAsyncEffect } from '../utils';
import SwapItem, { SwapItemSkeleton } from './SwapItem';

const SKELETON_COUNT = 4;

const SwapListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ListTitle = styled.h2`
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
`;

const SwapList: FC<{ watchingSwapId?: string }> = (props) => {
  const [swaps, setSwaps] = useState<Swap[]|null>(null);
  const userState = useContext(UserStateContext);
  
  useAsyncEffect(async () => {
    setSwaps(await getSwaps());
  }, [userState]);

  const otherSwaps = swaps?.filter(swap => swap.swapId != props.watchingSwapId);

  if (otherSwaps?.length == 0) {
    return null;
  }

  return <SwapListContainer>
    <ListTitle><Trans>Other videos</Trans></ListTitle>
    {otherSwaps
      ? otherSwaps.map(swap => <SwapItem key={swap.swapId} swap={swap} layout="row" />)
      : Array.from({ length: SKELETON_COUNT }, (_, index) => <SwapItemSkeleton key={index} layout="row" />)}
  </SwapListContainer>
};

export default SwapList;
